import React from 'react';
import { Dialog, Image, T } from '@colonist/ui';
import { emptyTranslation } from '@colonist/i18n';
import IconPrivateGame from '@static/images/icon_sunglasses.svg';
import IconHideBankCards from '@static/images/icon_hide_bank_card.svg';
import IconRobber from '@static/images/icon_robber.svg';
import IconDice6 from '@static/images/dice_6.svg';
import IconNoTroll from '@static/images/icon_no_troll.svg';
import IconProfileRanked from '@static/images/icon_profile_ranked.svg';
import styles from './RulesInfoDialog.module.scss';
const DECORATIVE = emptyTranslation;
const PRIVATE_GAME_RULE = {
    header: {
        key: 'strings:roomPage.rules.ruleInformation.privateGame.header'
    },
    text: {
        key: 'strings:roomPage.rules.ruleInformation.privateGame.body'
    },
    image: {
        src: IconPrivateGame,
        alt: DECORATIVE
    }
};
const HIDE_BANK_CARDS_RULE = {
    header: {
        key: 'strings:roomPage.rules.ruleInformation.hideBankCards.header'
    },
    text: {
        key: 'strings:roomPage.rules.ruleInformation.hideBankCards.body'
    },
    image: {
        src: IconHideBankCards,
        alt: DECORATIVE
    }
};
const FRIENDLY_ROBBER_RULE = {
    header: {
        key: 'strings:roomPage.rules.ruleInformation.friendlyRobber.header'
    },
    text: {
        key: 'strings:roomPage.rules.ruleInformation.friendlyRobber.body'
    },
    image: {
        src: IconRobber,
        alt: DECORATIVE
    }
};
const BALANCED_DICE_RULE = {
    header: {
        key: 'strings:roomPage.rules.ruleInformation.balancedDice.header'
    },
    text: {
        key: 'strings:roomPage.rules.ruleInformation.balancedDice.body'
    },
    image: {
        src: IconDice6,
        alt: DECORATIVE
    }
};
const NO_TROLLS_RULE = {
    header: {
        key: 'strings:roomPage.rules.ruleInformation.noTrolls.header'
    },
    text: {
        key: 'strings:roomPage.rules.ruleInformation.noTrolls.body'
    },
    image: {
        src: IconNoTroll,
        alt: DECORATIVE
    }
};
const ORDER_SELECTION_RULE = {
    header: {
        key: 'strings:roomPage.orderSelection.title'
    },
    text: {
        key: 'strings:roomPage.orderSelection.description'
    },
    image: {
        src: IconProfileRanked,
        alt: DECORATIVE
    }
};
function getVisibleRules(isTournamentRoom, isStoreDisabled) {
    const rules = [];
    if (!isTournamentRoom) rules.push(PRIVATE_GAME_RULE);
    rules.push(HIDE_BANK_CARDS_RULE);
    rules.push(FRIENDLY_ROBBER_RULE);
    rules.push(BALANCED_DICE_RULE);
    if (!isTournamentRoom && !isStoreDisabled) rules.push(NO_TROLLS_RULE);
    if (isTournamentRoom) rules.push(ORDER_SELECTION_RULE);
    return rules;
}
export const RulesInfoDialog = ({ open, onClose, isTournamentRoom, isStoreDisabled })=>{
    const rules = getVisibleRules(isTournamentRoom, isStoreDisabled);
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:roomPage.rules.title'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.rulesContainer
    }, rules.map((rule)=>/*#__PURE__*/ React.createElement("div", {
            key: rule.header.key,
            className: styles.ruleContainer
        }, /*#__PURE__*/ React.createElement(Image, {
            className: styles.ruleImage,
            image: rule.image
        }), /*#__PURE__*/ React.createElement("div", {
            className: styles.ruleTextContainer
        }, /*#__PURE__*/ React.createElement("h4", {
            className: styles.ruleHeader
        }, /*#__PURE__*/ React.createElement(T, {
            id: rule.header
        })), /*#__PURE__*/ React.createElement("p", {
            className: styles.ruleText
        }, /*#__PURE__*/ React.createElement(T, {
            id: rule.text
        }))))))));
};
